import React, { useState } from 'react';
import './SortingOptions.css';

function SortingOptions({ currentSort, onSortChange }) {
  const [isOpen, setIsOpen] = useState(false);

  const sortOptions = [
    { value: 'latest', label: 'Latest' },
    { value: 'price-low', label: 'Price: Low to High' },
    { value: 'price-high', label: 'Price: High to Low' },
    { value: 'featured', label: 'Featured' },
    { value: 'area-low', label: 'Area: Low to High' },
    { value: 'area-high', label: 'Area: High to Low' }
  ];

  const getCurrentLabel = () => {
    const option = sortOptions.find(opt => opt.value === currentSort);
    return option ? option.label : 'Latest';
  };

  const handleSelect = (value) => {
    onSortChange(value);
    setIsOpen(false);
  };

  return (
    <div className="sorting-options">
      <label className="sort-label">Sort by:</label>
      <div className="sort-dropdown">
        <button
          className="sort-dropdown-toggle"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span>{getCurrentLabel()}</span>
          <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>▼</span>
        </button>

        {isOpen && (
          <div className="sort-dropdown-menu">
            {sortOptions.map(option => (
              <button
                key={option.value}
                className={`sort-option ${currentSort === option.value ? 'active' : ''}`}
                onClick={() => handleSelect(option.value)}
              >
                {option.label}
                {currentSort === option.value && <span className="check-icon">✓</span>}
              </button>
            ))}
          </div>
        )}
      </div>

      {isOpen && (
        <div className="sort-backdrop" onClick={() => setIsOpen(false)} />
      )}
    </div>
  );
}

export default SortingOptions;
